import { Link } from "react-router-dom";

const Breadcrumb = ({ pageName, description }) => {
  return (
    <>
      <section className="relative z-10 overflow-hidden pt-28 lg:pt-[150px]">
        <div className="container">
          <div className="flex flex-wrap items-center">
            <div className="w-full px-3 xs:px-4">
              <div className="max-w-[570px] mb-4 sm:mb-8 lg:mb-12">
                <h1 className="-mx-[2px] lg:mb-2 text-2xl font-bold text-black dark:text-white sm:text-3xl">
                  {pageName}
                </h1>
                <div className="w-full">
                  <div>
                    <ul className="flex items-center md:justify-start">
                      <li className="flex items-center">
                        <Link
                          to="/"
                          className="pr-1 text-sm sm:text-base font-medium text-body-color hover:text-primary"
                        >
                          Home
                        </Link>
                        <span className="mr-3 block h-2 w-2 rotate-45 border-t-2 border-r-2 border-body-color"></span>
                      </li>
                      <li className="text-sm sm:text-base font-medium text-primary">
                        {pageName}
                      </li>
                    </ul>
                  </div>
                </div>
                <p className="mt-2 text-sm sm:text-base font-medium leading-relaxed text-body-color">
                  {description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Breadcrumb;
